import FormPoster from "@/js/libs/formPoster";
import summary from "@/js/parts/checkout/refreshSummary";
import isInCart from "@/js/libs/isInCart";
import { ErrorsGroup } from "@/js/libs/form-errors";

let APP = window.APP || {};

// One big init function, assume polyfils and docready when this is called:
export default function (form) {
  let Form = new FormPoster({
    form: form,
  });

  if (!Form.ready) {
    return;
  }

  var checkFields = form.querySelectorAll("select, input, textarea");
  var errors = new ErrorsGroup(checkFields);

  Form.validateOnSubmitButtons(errors);

  Form.onSubmit((e) => {
    // Stop page submitting:
    e.preventDefault();

    // True => Report errors
    var isValid = errors.validate(true);

    if (!isValid) {
      errors.focusFirstError();
      return;
    }

    // Make the page look like it's loading:
    summary.loading();
    Form.states.loading();
    Form.updateFormValues();

    var purchasableId = Form.formData.get("purchasableId");

    // AJAX Post the form...
    Form.post((json) => {
      if (isInCart(json.cart, purchasableId)) {
        window.location = Form.formData.get('redirect') || Form.form.getAttribute('action') || window.location.href;
        return;
      } else {
        console.log("Item was not added to cart.");
        APP.showModal("Sorry, that option was not available");
        summary.refresh(Form.states.ready);
        return;
      }
    });
  });
}
